import React, { useEffect, useState } from "react";
import background from "../../../_assets/media/login_back.jpg";
import Logo from "../../../_assets/media/favicon.png";
import { useForm } from "react-hook-form";
import { Alert } from "reactstrap";

import logo from "../../../_assets/media/home/logo.png";
import header1 from "../../../_assets/media/home/header1.jpg";
import header2 from "../../../_assets/media/home/header2.jpg";
import header3 from "../../../_assets/media/home/header3.jpg";
import { postMethod } from "../../../_services/_postMethod";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

import NumberFormat from "react-number-format";
import { API_BASE_URL } from "../../../_services/constant";

import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  outerContainer: {
    minHeight: "calc(100vh - 50px)",
    padding: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundSize: "cover",
    backgroundPosition: "center",
    [theme.breakpoints.down("xs")]: {
      padding: "0px 0px 16px 0px",
      alignItems: "flex-start",
    },
  },
  cardWrapper: {
    width: "100%",
    maxWidth: "1100px",
    borderRadius: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    backdropFilter: "blur(8px)",
    padding: "48px",
    [theme.breakpoints.down("xs")]: {
      backgroundColor: "transparent !important",
      backdropFilter: "none !important",
      boxShadow: "none !important",
      borderRadius: 0,
      padding: "0px !important",
    },
  },
  logoContainer: {
    marginBottom: "48px",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "24px",
      marginTop: "24px",
      paddingTop: "12px",
    },
  },
  logoImg: {
    maxHeight: "120px",
    maxWidth: "260px",
    objectFit: "contain",
    [theme.breakpoints.down("xs")]: {
      maxHeight: "120px",
      maxWidth: "260px",
      marginTop: "20px",
      marginBottom: "20px",
    },
  },
  mainImageContainer: {
    minHeight: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      minHeight: "auto",
      marginBottom: "16px",
      padding: "0px !important",
      width: "100%",
    },
  },
  bannerImageWrapper: {
    position: "relative",
    width: "100%",
    maxWidth: "320px",
    display: "inline-block",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      top: "10px",
      left: "10px",
      right: "10px",
      bottom: "10px",
      border: "1.5px solid rgba(255, 255, 255, 0.85)",
      pointerEvents: "none",
      borderRadius: "4px",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
  },
  bannerImage: {
    width: "100%",
    maxWidth: "320px",
    height: "400px",
    objectFit: "cover",
    borderRadius: "8px",
    transition: "opacity 0.5s ease-in-out",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      maxWidth: "100%",
      height: "480px",
      borderRadius: "0px",
      display: "block",
    },
  },
  subText: {
    fontSize: "15px",
    fontWeight: 400,
    color: "#6c757d",
    marginBottom: "24px",
    [theme.breakpoints.down("xs")]: {
      fontWeight: 700,
      color: "#1a1a1a",
      fontSize: "16px",
      textAlign: "center",
      marginBottom: "16px",
    },
  },
  formFlexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "10px",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "0px",
    },
  },
  mobileInput: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "10px 14px",
    width: "100%",
    fontSize: "15px",
    color: "#333",
    backgroundColor: "#fff",
    boxSizing: "border-box",
    [theme.breakpoints.up("md")]: {
      maxWidth: "400px",
      borderRadius: "4px",
      padding: "12px 15px",
      fontSize: "16px",
      color: "#555",
    },
  },
  submitWrapper: {
    marginTop: "0px",
    display: "inline-block",
    [theme.breakpoints.up("md")]: {
      marginTop: "20px",
      display: "block",
      width: "100%",
    },
  },
  submitBtn: {
    backgroundColor: "#ffc107",
    color: "#222",
    padding: "10px 24px",
    borderRadius: "8px",
    border: "none",
    fontWeight: "700",
    fontSize: "16px",
    height: "44px",
    minWidth: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "none",
    cursor: "pointer",
    [theme.breakpoints.up("md")]: {
      backgroundColor: "#1bc5bd",
      color: "white",
      padding: "10px 40px",
      borderRadius: "4px",
      fontWeight: "600",
      height: "auto",
      minWidth: "auto",
      boxShadow: "0 2px 5px rgba(27, 197, 189, 0.3)",
      display: "inline-block",
    },
  },
}));
const TrialWelcome = (props) => {
  const classes = useStyles();
  const [otp, setOtp] = useState(false);
  const [imgObj, setimgObj] = useState({ image1: "", image2: "", image3: "" });
  const { register, handleSubmit, errors } = useForm();
  const [isvalid, setValid] = useState(false);
  const [load, setLoad] = useState(false);
  const [otpVal, setotpVal] = useState(false);
  const [mobileVal, setmobileVal] = useState(false);
  const [mobile, setmobile] = useState("");
  const [branchLogo, setBranchLogo] = useState("");
  const [branchid, setBranchid] = useState("");
  const [year, setyear] = useState("");
  const [branchName, setBranchName] = useState("");
  const [branchFacebook, setBranchFacebook] = useState("");
  const [branchInstagram, setBranchInstagram] = useState("");
  const [branchTwitter, setBranchTwitter] = useState("");
  const [branchLinkedin, setBranchLinkedin] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const images = [imgObj?.image1, imgObj?.image2, imgObj?.image3].filter(img => img);
    if (images.length > 1) {
      const interval = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % images.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [imgObj]);
  const loginCustomer = (values) => {
    var mobile = values.mobile
      .trim()
      .replace("+91", "")
      .replace(/ /g, "")
      .replace(/_/g, "");
    values.mobile = mobile;
    values.encrypt_id = branchid;
    if (mobile.length == 10) {
      setLoad(true);

      if (otp) {
        postMethod(`auth/trial/token`, values).then((dataD) => {
          const data = dataD?.data?.[0];
          if (data) {
            localStorage.setItem("jwl_login", true);
            localStorage.setItem("type", "trialSession");
            localStorage.setItem("jwl_token", data.access_token);
            localStorage.setItem("jwl_username", data.full_name);
            localStorage.setItem("jwl_logo", data.logo);
            localStorage.setItem("jwl_brand_name", data.brand_name);
            localStorage.setItem("jwl_banner_path", data.banner_path);
            localStorage.setItem("jwl_customer_id", data.customer_id);
            localStorage.setItem("jwl_customer_branch_id", data.branch_id);
            localStorage.setItem("jwl_customer_vcall", data.vcall_trial);
            localStorage.setItem("jwl_hide_price", data.hide_price);
            localStorage.setItem("cust_mobile", mobile);

            window.location = `/trial-view/home`;
          } else {
            setotpVal(!otpVal);
            setValid(true);
          }
          setLoad(false);
        });
      } else {
        values.mobile = mobile
          .trim()
          .replace("+91", "")
          .replace(" ", "")
          .replace(" ", "")
          .replace(" ", "");
        postMethod(`auth/trial/login`, values).then((dataD) => {
          var data = dataD.data[0];
          if (data.valid === true) {
            localStorage.setItem("cust_mobile", values.mobile);
            setOtp(true);
            setValid(false);
          } else {
            setOtp(false);
            setValid(true);
          }
          setLoad(false);
        });
      }
    } else {
      setmobileVal(true);
    }
  };

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    var token = query.get("t");
    setBranchid(token);
    localStorage.clear();
    setyear(new Date().getFullYear());
    postMethod("public/Trialimages", { branch_id: token }).then((data) => {
      // debugger
      if (data.data.length > 0) {
        setimgObj(data.data[0]);
      }
    });
    setLoad(true);
    postMethod("public/branch_details", { branch_id: token }).then((data) => {
      setBranchLogo(data.data[0].logo);
      setBranchName(data.data[0].company_name);
      setBranchFacebook(data.data[0].facebook);
      setBranchInstagram(data.data[0].instagram);
      setBranchTwitter(data.data[0].twitter);

      localStorage.setItem("jwl_facebook", data.data[0].facebook);
      localStorage.setItem("jwl_branch_mobile", data.data[0].branch_mobile);
      localStorage.setItem("jwl_instagram", data.data[0].instagram);
      localStorage.setItem("jwl_twitter", data.data[0].twitter);
      setLoad(false);
    });
  }, []);

  return (
    <React.Fragment>
      <Backdrop className={classes.backdrop} open={load}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <div
        className={`customcontainer tag_wrapper ${classes.outerContainer}`}
      >
        <div
          className={`shadow-lg ${classes.cardWrapper}`}
        >
          <div className={`row ${classes.logoContainer}`}>
            <div className="col-12 text-center">
              {branchLogo ? (
                <img
                  src={API_BASE_URL + "BranchLogo/" + branchLogo}
                  className={`logo ${classes.logoImg}`}
                  alt="Logo"
                />
              ) : (
                <Skeleton variant="rectangular" width={100} height={80} style={{ margin: "auto" }} />
              )}
            </div>
          </div>

          <div className="row align-items-center">
            <div className={`col-md-5 text-center mb-4 mb-md-0 ${classes.mainImageContainer}`}>
              {[imgObj?.image1, imgObj?.image2, imgObj?.image3].filter(img => img).length > 0 ? (
                <div className={classes.bannerImageWrapper}>
                  <img
                    src={API_BASE_URL + "Images/" + [imgObj?.image1, imgObj?.image2, imgObj?.image3].filter(img => img)[currentImageIndex]}
                    className={`shadow-sm ${classes.bannerImage}`}
                    alt="Banner"
                  />
                </div>
              ) : (
                <Skeleton variant="rectangular" width={320} height={400} />
              )}
            </div>

            <div className="col-md-7 px-md-5 px-3">
              <div className="tophead text-left">
                <h6
                  className="text-uppercase text-muted mb-3 d-none d-md-block"
                  style={{ fontSize: "12px", letterSpacing: "1.5px", fontWeight: "600" }}
                >
                  UNIQUE ACCESSORIES
                </h6>
                <h2
                  className="font-weight-bold mb-3 d-none d-md-block"
                  style={{ color: "#222", fontSize: "32px", fontWeight: "700" }}
                >
                  Your Exclusive Collection
                </h2>
                <p className={classes.subText}>
                  Crafting Exquisite Designs for you..
                </p>
                <form onSubmit={handleSubmit(loginCustomer)}>
                  <div className={classes.formFlexRow}>
                    <div
                      className={"group subs " + (!otp ? "" : "hide")}
                      style={{ marginBottom: "0px", flex: 1, width: "100%" }}
                    >
                      <NumberFormat
                        getInputRef={register}
                        onValueChange={(e) => {
                          setmobileVal(false);
                        }}
                        name="mobile"
                        format="+91 ### ### ####"
                        allowEmptyFormatting
                        mask="_"
                        className={`form-control ${classes.mobileInput}`}
                      />
                      {mobileVal ? (
                        <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                          Incorrect mobile no.
                        </p>
                      ) : null}
                    </div>

                    <div
                      className={"group subs " + (!otp ? "hide" : "")}
                      style={{ marginBottom: "0px", flex: 1, width: "100%" }}
                    >
                      <input
                        className={`form-control ${classes.mobileInput}`}
                        ref={register}
                        type="number"
                        placeholder="Enter 6-digit OTP"
                        name="otp"
                        autoComplete="off"
                        onClick={() => {
                          setotpVal(false);
                        }}
                      />
                      {otpVal ? (
                        <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                          Incorrect OTP.
                        </p>
                      ) : null}
                    </div>
                    <div className={`sbmt ${classes.submitWrapper}`}>
                      <button
                        type="submit"
                        className={`btn ${classes.submitBtn}`}
                      >
                        Go
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="tag_footer" style={{ backgroundColor: "#ffc107", color: "#333", padding: "12px 0", width: "100%" }}>
        <div className="container mcntr">
          <div className="row align-items-center text-center text-sm-left">
            <div className="col-12 col-sm-6 mb-2 mb-sm-0" style={{ fontSize: "13px", fontWeight: "600" }}>
              © {year} {branchName} All Rights Reserved
            </div>
            <div className="col-12 col-sm-6">
              <div className="d-flex justify-content-center justify-content-sm-end align-items-center" style={{ gap: "20px" }}>
                {branchFacebook ? (
                  <a href={branchFacebook} style={{ color: "#333" }}>
                    <i
                      id="social-fb"
                      className="fa fa-facebook fa-lg social"
                    ></i>
                  </a>
                ) : null}
                {branchInstagram ? (
                  <a href={branchInstagram} style={{ color: "#333" }}>
                    <i
                      id="social-gp"
                      className="fa fa-instagram fa-lg social"
                    ></i>
                  </a>
                ) : null}
                {branchLinkedin ? (
                  <a href={branchLinkedin} style={{ color: "#333" }}>
                    <i
                      id="social-em"
                      className="fa fa-linkedin fa-lg social"
                    ></i>
                  </a>
                ) : null}
                {branchTwitter ? (
                  <a href={branchTwitter} style={{ color: "#333" }}>
                    <i
                      id="social-tw"
                      className="fa fa-twitter fa-lg social"
                    ></i>
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default TrialWelcome;
